import { FilterSortType } from '@/components/sections/builder/elements/body/collection-product-grid/content';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { ThemeColorSchemeType } from '@/stores/builder';
import { BaseProductCategory } from '@/types/http/product/common';
import React from 'react';

type CardCategoryProps = {
  categories: BaseProductCategory[];
  isLoading: boolean;
  filter: FilterSortType;
  setCategory: React.Dispatch<React.SetStateAction<string>>;
  onSelectCategory: (id: string, name: string) => void;
  colorScheme?: ThemeColorSchemeType;
  isHideTitle?: boolean;
};

export default function CardCategory({
  categories,
  isLoading,
  filter,
  setCategory,
  onSelectCategory,
  colorScheme,
  isHideTitle,
}: CardCategoryProps) {
  const [active, setActive] = React.useState<string>(filter.categoryId as string);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCategory(e.target.value);
    setActive(e.target.value);
  };
  return (
    <div className='flex flex-col'>
      {!isHideTitle && <h4 className='text-sm'>Category:</h4>}
      <RadioGroup
        name='categoryId'
        value={filter.categoryId}
        className={cn('py-2', !isHideTitle && 'mt-2')}
      >
        <Input
          type='text'
          placeholder='Search'
          className='w-full px-2 py-0 text-sm'
          onChange={handleSearch}
        />
        <div className='flex max-h-[400px] flex-col gap-2 overflow-y-auto'>
          {isLoading ? (
            Array.from({ length: 3 as number }).map((_, index) => (
              <Skeleton className='h-4 w-full' key={index} />
            ))
          ) : categories.length > 0 ? (
            categories.map((category) => (
              <div
                key={category.category_id}
                className='flex cursor-pointer items-center space-x-2 py-1.5'
                onClick={() => onSelectCategory(category.category_id, category.category_name)}
              >
                <RadioGroupItem
                  value={category.category_id}
                  id={category.category_name}
                  style={
                    active === category.category_id
                      ? {
                          color: colorScheme?.btnSolidBackgroud,
                          borderColor: colorScheme?.btnSolidBackgroud,
                        }
                      : {
                          borderColor: colorScheme?.btnSolidBackgroud,
                        }
                  }
                  colorCircle={colorScheme?.btnSolidBackgroud}
                  isCustom
                />
                <Label
                  htmlFor={category.category_name}
                  className={cn(
                    'cursor-pointer text-sm',
                    filter.categoryId === category.category_id ? 'font-medium' : 'font-normal'
                  )}
                >
                  {category.category_name}
                </Label>
              </div>
            ))
          ) : (
            <span className='text-center text-sm'>No category found.</span>
          )}
        </div>
      </RadioGroup>
    </div>
  );
}
